import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Button from '../../lib/ui/buttons/Button';
import InputField from '../../lib/ui/inputs/Input';
import DropDown from "../../lib/ui/dropdown/Dropdown";
import LogoBranding from '../../lib/ui/logoBranding/LogoBranding';
import { LangCtx, CustomCtx } from "../../lib/context";
import { langObj } from "../../locale/index";
import 'react-phone-number-input/style.css';
import '../../lib/ui/imageicon/Styles.css';
import '../../lib/ui/inputs/InputStyles.css';
import "../../layouts/Layouts.css";
import "../../ui-styles/picker/picker.css";
// import statesList from "../../config/states.json";
// import citiesList from "../../config/cities.json";
// import titlesList from "../../config/titles.json";
// import countriesList from "../../config/countries.json";
// import
//     {
//         KeyboardDatePicker,
//         MuiPickersUtilsProvider,
//     } from '@material-ui/pickers';
import { validateEmail, validateLetters, validatePassword } from "../../lib/validation";

import { patientsignup } from "../../actions/users";
// import config from '../../config.json';
// import { dateFormat } from '../../lib/functions';
// import AddrDropDown from '../../lib/ui/dropdown/addressDropDown';
import { Auth, API } from "aws-amplify";
import Loader from "../../lib/ui/loader/Loader";
// import bloodgroups from "../../config/bloodgroup.json";
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import { getTerms } from '../../actions/configuration';
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { getSubdomain } from '../../lib/domain';


// const psl = require('psl');

//const titlesList = [{value: "", label:"Select"},{ value: "Mr", label: "Mr." }, { value: "Mrs", label: "Mrs." }, { value: "Ms", label: "Ms." }, { value: "Master", label: "Master" }, { value: "Miss", label: "Miss" }]
const PatientSignupPage = (props) =>
{
    const { l, setLang } = useContext(LangCtx);
    const { custom } = useContext(CustomCtx);
    const history = useHistory();

    // const [ gender, setGender ] = React.useState('');
    const [ errorMsg, setErrorMsg ] = useState('');
    const [ error, setError ] = useState({});
    const [ firstName, setfirstName ] = useState('');
    // const [ lastName, setLastName ] = useState('');
    //    const [civilNumber, setCivilNumber] = useState('');
    const [ email, setEmail ] = useState('');
    // const [ phone, setPhone ] = useState('');
    // const [ dob, setDob ] = useState(new Date().valueOf());
    // const [ bloodgroup, setBloodgroup ] = useState('');
    // const [ states, setStates ] = useState([ {
    //     value: "",
    //     label: l.select_state
    // }, ]);
    // const [ cities, setCities ] = useState([ {
    //     value: "",
    //     label: l.select_city
    // }, ]);
    // const [ address, setAddress ] = useState('');
    // const country = 'India';
    // const  state= '';
    // const [ city, setCity ] = useState('');
    // const [ title, setTitle ] = useState('');
    const [ password, setPassword ] = useState('');
    const [ confirmpassword, setConfirmPassword ] = useState('');
    const [ loading, setLoading ] = useState(false);
    const [signupFieldsData, setSignupFieldsData] = useState({checkedFirst:false, checkedSecond:false, checkedThird:false})

    // const _domain = psl.parse(window.location.hostname);
    const _domain = getSubdomain(window.location.hostname);

    const langOptions = [ { value: "en", label: l.english }, { value: "hi", label: l.hindi }, { value: "fr", label: l.french } ];
    const [support,setSupport]=useState({})
    // const url= window.location.href.includes('localhost') ? `${process.env.REACT_APP_appURL}/terms-conditions` : `${window.location.href}terms-conditions`;
    // const patientconcern = window.location.href.includes('localhost') ? `${process.env.REACT_APP_appURL}/patient-concern` : `${window.location.href}patient-concern`;
    
    const handleLang = (e) =>
    {
        setLang(langObj[ e.target.value ]);
        localStorage.setItem('lang', e.target.value);
    };

    const handleGet = () =>
    {
        setLoading(true);
        let query = `?subdomain=${window.location.hostname !== "localhost" ? _domain.subdomain : process.env.REACT_APP_defaultdomian}`;
        if(window.location.hostname!=="localhost" && !window.location.hostname.includes("app")){
        getTerms(query).then((res) =>
        {
            
            if (res?.status && res?.data) {
                setSupport({
                    phone: res?.data?.phone,
                    email: res?.data?.email,
                    terms: res?.data?.terms || "", 
                    brandName: res?.data?.brandName,
                    concern: res?.data?.concern || ''
                });
            } else {
                setSupport({
                    phone: '',
                    email: '',
                    terms: "",
                    brandName: 'instavc',
                    concern: ''
                });
            }
    
            setLoading(false);
        }).catch(e => {
            console.log(e);
            setSupport({
                phone: '',
                email: '',
                terms: "",
                brandName: 'instavc',
                concern: ''
            });
            setLoading(false);
        });
    }else{
        setSupport("");
        setLoading(false)
    }
    ;}
    

    useEffect(() =>
    {
        handleGet();
    }, []);

    // useEffect(() => {
    //     let _statesList = statesList.filter((state) => state.countryid === country);
    //     _statesList.unshift({
    //         value: "",
    //         label: l.select_state
    //     });
    //     _statesList.sort((a,b)=> a.value < b.value? -1:a.value > b.value? 1:0)
    //     setStates([..._statesList]);
    //     setCities([{ value: "", label: l.select_city }]);
    // }, [country]);

    // useEffect(() => {
    //     let _citiesList = citiesList.filter((city) => city.stateid === state);
    //     if (_citiesList.length === 0) {
    //         _citiesList = [{
    //             value: "",
    //             label: l.no_cities_available
    //         }];
    //     } else {
    //         _citiesList.unshift({
    //             value: "",
    //             label: l.select_city
    //         });
    //     }
    //     _citiesList.sort((a,b)=> a.value < b.value? -1:a.value > b.value? 1:0)
    //     setCities(_citiesList);
    // }, [state]);

    const validate = () =>
    {
        let _error = {};
        let returnValue = true;


        if(!signupFieldsData.checkedFirst){
            _error["checkedFirst"] = true;
            returnValue = false;
        }

        if(!signupFieldsData.checkedSecond){
            _error["checkedSecond"] = true;
            returnValue = false;
        }

        if(!signupFieldsData.checkedThird){
            _error["checkedThird"] = true;
            returnValue = false;
        }

        // if (title === '' || title == null) {
        //     _error['title'] = l.pls_ent_title
        //     returnValue = false
        // }
        if (firstName === '' || firstName == null)
        {
            _error[ 'firstName' ] = l.pls_ent_fName;
            returnValue = false;
        }
        else if (!validateLetters(firstName))
        {
            _error[ 'firstName' ] = l.pls_ent_letters_fName;
            returnValue = false;
        }
        // if (lastName === '' || lastName == null) {
        //     _error['lastName'] = l.pls_ent_lName
        //     returnValue = false
        // }
        // else if (!validateLetters(lastName)) {
        //     _error['lastName'] = l.pls_ent_letters_lName
        //     returnValue = false;
        // }
        if (email === '' || email == null)
        {
            _error[ 'email' ] = l.pls_enter_email;
            returnValue = false;
        }
        else if (!validateEmail(email))
        {
            _error[ 'email' ] = l.pls_check_email;
            returnValue = false;
        }
        // if (phone === '' || phone == null) {
        //     _error['phone'] = l.pls_enter_phone
        //     returnValue = false
        // }
        // else if (!isValidPhoneNumber(phone)) {
        //     _error['phone'] = l.pls_check_phone
        //     returnValue = false
        // }
        // if (gender === '' || gender == null) {
        //     _error['gender'] = l.pls_sel_gender
        //     returnValue = false
        // }
        // if (dob === '' || dob == null) {
        //     _error['dob'] = l.pls_sel_dob
        //     returnValue = false
        // }
        // else if (!validateDate(dob)) {
        //     _error['dob'] = l.pls_check_dob
        //     returnValue = false
        // }
        // if (bloodgroup === '' || bloodgroup == null) {
        //     _error['bloodgroup'] = l.pls_sel_bldgp
        //     returnValue = false
        // }
        // if (address === '' || address == null) {
        //     _error['address'] = l.pls_sel_dob
        //     returnValue = false
        // }
        // if (country === '' || country == null) {
        //     _error['country'] = l.pls_sel_country
        //     returnValue = false
        // }
        // if (state === '' || state == null) {
        //     _error['state'] = l.pls_sel_state
        //     returnValue = false
        // }
        // if (city === '' || city == null) {
        //     _error['city'] = l.pls_sel_city
        //     returnValue = false
        // }
        if (password === '')
        {
            _error[ 'password' ] = l.pls_ent_new_pwd;
            returnValue = false;
        }
        else if (password !== '' && !validatePassword(password))
        {
            _error[ 'password' ] = l.ent_valid_pwd;
            returnValue = false;
        }

        if (confirmpassword === '')
        {
            _error[ 'confirmpassword' ] = l.pls_ent_conf_pwd;
            returnValue = false;
        }
        else if (confirmpassword !== '' && !validatePassword(confirmpassword))
        {
            _error[ 'confirmpassword' ] = l.ent_valid_confPwd;
            returnValue = false;
        }

        if (password !== confirmpassword)
        {
            _error[ 'confirmpassword' ] = l.psw_confpsw_should_same;
            returnValue = false;
        }

        setError(_error);
        return returnValue;

    };

    const handleSignupBtn = async e =>
    {
        e.preventDefault();
        try
        {
            if (validate())
            {
                setErrorMsg('');
                setLoading(true);
                // const phoneNumber = parsePhoneNumber(phone)
                // const countrycode = phoneNumber.countryCallingCode;
                // const number = phoneNumber.nationalNumber;
                let body = {
                    title: '',
                    firstName: firstName.trim(),
                    lastName: '',
                    email: email.replaceAll(' ', '').toLowerCase(),
                    //        civilNumber: civilNumber.trim(),
                    countryCode: '',
                    phone: '',
                    gender: '',
                    bloodgroup: '',
                    dob: '',
                    address: '',
                    country: '',
                    stateName: '',
                    city: '',
                    password: password,
                    assignedTo: custom.defaultClinicId,
                    clinicId: custom.defaultClinicId,
                    domain: _domain && _domain.subdomain ? _domain.subdomain : custom.subDomain
                    // domain: 'inclinix'
                    // adminId: config.defaultClinicAdminId
                };
                if (process.env.REACT_APP_isOffline === "true")
                {
                    patientsignup(body)
                        .then(res =>
                        {
                            history.push('/');
                            // history.push('/verify-account?phone=' + phone.trim());
                        })
                        .catch(err =>
                        {
                            let msg = err?.response?.data ? err.response.data.error : l.unable_upd_patient;
                            setErrorMsg(msg);
                            setLoading(false);
                        });
                } else
                {
                    if (custom.defaultClinicId && custom.defaultClinicId !== null)
                    {
                        const cognito_body = {
                            // name: firstName.trim() + ' ' + lastName.trim(),
                            // 'custom:title':'',
                            'custom:fname': firstName.trim(),
                            // 'custom:lname': '',
                            'custom:email': email.trim().replaceAll(' ', '').toLowerCase(),
                            // 'custom:phone': '',
                            // 'custom:gender': '',
                            // 'custom:dob': '',
                            // phone_number: '',
                            // 'custom:Street': division,
                            // address: '',
                            // 'custom:State': '',
                            // 'custom:District': '',
                            // 'custom:Country': '',
                            'custom:consult_assignedTo': custom.defaultClinicId,
                            'custom:clinicId': custom.defaultClinicId,
                            // 'custom:adminId': config.defaultClinicAdminId,
                            'custom:consultRole': "patient",
                            "custom:domain": _domain && _domain.subdomain ? _domain.subdomain : custom.subDomain
                            // "custom:domain": 'inclinix'
                        };
                        // let phoneNumber = phone.trim();
                        const newUser = await Auth.signUp({
                            // username: phone.trim(),
                            username: email.trim().replaceAll(' ', '').toLowerCase(),
                            password: password,
                            attributes: cognito_body,
                        });

                        if (newUser.userSub)
                        {
                            body[ 'userSub' ] = newUser.userSub;
                            API.post("users", "/createuser", { body })
                                .then(res =>
                                {
                                    // return dispatch(setProfile(res.data));
                                    history.push('/verify-account?username=' + email.trim());
                                })
                                .catch(err =>
                                {
                                    console.log("err in getProfile ", err.message);
                                    let msg = err?.response?.data?.error ? err.response.data.error : l.unable_upd_patient;
                                    msg === 'Password did not conform with policy: Password not long enough' &&(msg = 'Password not long enough')
                                    setErrorMsg(msg);
                                    setLoading(false);
                                });
                        }
                    } else
                    {
                        setErrorMsg("Please contact Admin");
                        setLoading(false);
                    }
                }

            }
            else
            {
                if (errorMsg != null)
                {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }
            }
        } catch (err)
        {
            console.log("Error", err);
            let msg = err && err.message ? err.message : l.unable_upd_patient;
            setErrorMsg(msg);
            setLoading(false);
        }

    };

    const handleOpenGmail = (email) =>
	{
		const os = navigator.userAgent;
		let width, height, left, top;

		if (os.search('Windows') !== -1)
		{
			// finalOs = 'Windows';
			width = window.innerWidth / 2;
			height = window.innerHeight / 2;
			left = (window.innerWidth - width) / 4;
			top = (window.innerHeight - height) / 4;
		}
		else if (os.search('Mac') !== -1)
		{
			// finalOs = 'MacOS';
			width = window.innerWidth / 2;
			height = window.innerHeight / 2;
			left = (window.innerWidth - width) / 2;
			top = (window.innerHeight - height) / 2;
		}
		else if (os.search('X11') !== -1 && !(os.search('Linux') !== -1))
		{
			// finalOs = 'UNIX';
			width = window.innerWidth / 2;
			height = window.innerHeight / 2;
			left = (window.innerWidth - width) / 2;
			top = (window.innerHeight - height) / 2;
		}
		else if (os.search('Linux') !== -1 && os.search('X11') !== -1)
		{
			// finalOs = 'Linux';
			width = window.innerWidth / 2;
			height = window.innerHeight / 2;
			left = (window.innerWidth - width) / 2;
			top = (window.innerHeight - height) / 2;
		}
		window.open(
			`https://mail.google.com/mail/?view=cm&fs=1&to=${email}`,
			'popup',
			`width=${width},height=${height},left=${left},top=${top}`
		);
	};


    return <Fragment>
        <div className="coverContainer">
            <div className="outSideContainer">
                <div className="colCredential">
                    <div className="topRow">
                        <div className="langBlock">
                            {_domain?.subdomain === process.env.REACT_APP_defaultdomian && <div className="helpBtn DeskDisplayorNot">
                                <a className='logintollfree flexInline alignCntr' rel="noopener noreferrer" href="https://help.instavc.com/inclinic" target="_blank">
                                    <PlayCircleFilledWhiteIcon className='callIcon' fontSize='small' />{l.help_center}
                                </a>
                            </div>}
                            {/* <div className="helpBtn mobDisplayorNot">
                                <a className='logintollfree flexInline alignCntr' href="https://help.instavc.com/inclinic" target="_blank">
                                    <PlayCircleFilledWhiteIcon className='callIcon' fontSize='small' />{l.help}
                                </a>
                            </div> */}
                            <DropDown placeholder="Languages" items={langOptions} value={localStorage.getItem('lang') ? localStorage.getItem('lang') : l.locale} onChange={handleLang} />
                        </div>
                    </div>
                    {loading && <Loader />}
                    <div className="bodyRow">
                        <div className="brandingBlock">
                            <LogoBranding />
                        </div>
                        <div className="crdFormBlock">
                            <div className="crdHeadingBlock justifyCenter">
                                <h2 className="headingTxt">{l.sign_as_patient}</h2>
                            </div>

                            {errorMsg && errorMsg !== "" && <div className="errorBox">
                                <small className="errorTxt">{errorMsg}</small>
                            </div>
                            }

                            <div className="colBlock">
                                <div className="rowBlock">
                                    {/* <div className="inputRowGroup flex0 mrgRight8">
                                        <small className="inpLabel">{l.label_title}<span className="redTxt">*</span>:</small>
                                        <AddrDropDown
                                            placeholder={l.select_title}
                                            items={titlesList}
                                            value={title}
                                            error={error && error.title}
                                            errorMsg={error.title}
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                    </div> */}
                                    <div className="inputRowGroup mrgRight8">
                                        <small className="inpLabel">{l.fullname}<span className="redTxt">*</span>:</small>
                                        <InputField
                                            name="firstName"
                                            placeholder={l.fullname}
                                            type="text"
                                            value={firstName}
                                            error={error && error.firstName}
                                            errorMsg={error.firstName}
                                            maxLength="30"
                                            onChange={(e) => {
                                                setfirstName(e.target.value)
                                                setError({...error, firstName: ""})
                                            }
                                            }
                                        />
                                    </div>
                                    {/* <div className="inputRowGroup">
                                        <small className="inpLabel">{l.inp_lname}<span className="redTxt">*</span>:</small>
                                        <InputField
                                            placeholder={l.inp_lname}
                                            name="lastName"
                                            type="text"
                                            value={lastName}
                                            error={error && error.lastName}
                                            errorMsg={error.lastName}
                                            maxLength="30"
                                            onChange={(e) => setLastName(e.target.value)}
                                        />
                                    </div> */}
                                </div>
                                {/* <div className="inputBox colBlock nopdng">
                                    <small className="inpLabel">{l.phone_no}<span className="redTxt">*</span>:</small>
                                    <PhoneInput className="customPkgInput"
                                        international
                                        countryCallingCodeEditable={false}
                                        defaultCountry="IN"
                                        maxLength="17"
                                        value={phone}
                                        error={error && error.phone}
                                        errorMsg={error.phone}
                                        onChange={setPhone} />
                                    <label>{props.label}</label>
                                    {(error && error.phone) && <span className="inputErrorMsg">{error.phone}</span>}
                                </div> */}
                                <small className="inpLabel">{l.email_address}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.email_address}
                                    type="email"
                                    value={email?.replaceAll(' ', '').toLowerCase()}
                                    error={error && error.email}
                                    errorMsg={error.email}
                                    maxLength="50"
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                        setError({...error, email: ""})
                                        }
                                    }
                                />
                                {/* <div className="inputRowFeild">
                                    <small className="inpLabel">{l.label_gender}<span className="redTxt">*</span>:</small>
                                    <div className="hozRadioGroup">
                                        <div className={gender === "male" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                            <Radio id="male" name="gender" value="male" checked={gender === "male" ? true : false} onChange={(e) => setGender(e.target.value)} />
                                            <span>{l.male}</span>

                                        </div>
                                        <div className={gender === "female" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                            <Radio id="female" name="gender" value="female" checked={gender === "female" ? true : false} onChange={(e) => setGender(e.target.value)} />
                                            <span >{l.female}</span>
                                        </div>
                                        <div className={gender === "others" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                            <Radio id="others" name="gender" value="others" checked={gender === "others" ? true : false} onChange={(e) => setGender(e.target.value)} />
                                            <span>{l.others}</span>
                                        </div>
                                    </div>
                                    {(error && error.gender) && <span className="inputErrorMsg">{error.gender}</span>}
                                </div>  */}
                                {/* <div className="rowBlock alignCenter">
                                    <div className="inputRowGroup mrgRight8">
                                        <small className="inpLabel">{l.dob}<span className="redTxt">*</span>:</small>
                                        <div className="inputBox alignCenter">
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker fullWidth
                                                    className="pickerInput"
                                                    inputVariant="outlined"
                                                    value={dob}
                                                    onChange={(date) => setDob(date && date.valueOf())}
                                                    animateYearScrolling
                                                    placeholder={l.dob}
                                                    format="dd/MM/yyyy"
                                                    maxDate={new Date()}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        {(error && error.dob) && <span className="inputErrorMsg">{error.dob}</span>}
                                    </div>
                                    <div className="inputRowGroup ">
                                        <small className="inpLabel">{l.select_bldgrp}<span className="redTxt">*</span>:</small>
                                        <DropDown
                                            placeholder={l.select_bldgrp}
                                            items={bloodgroups}
                                            value={decodeURIComponent(bloodgroup)}
                                            error={error && error.bloodgroup}
                                            errorMsg={error.bloodgroup}
                                            onChange={(e) => setBloodgroup(encodeURIComponent(e.target.value))}
                                        />
                                    </div>
                                </div> */}

                                {/* <small className="inpLabel">{l.pat_address}:</small>
                                <InputField
                                    placeholder={l.pat_address}
                                    type="text"
                                    value={address}
                                    maxLength="100"
                                    error={error && error.address}
                                    errorMsg={error.address}
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                                <small className="inpLabel">{l.select_country}<span className="redTxt">*</span>:</small>
                                <AddrDropDown
                                    placeholder={l.select_country}
                                    items={countriesList}
                                    value={country}
                                    error={error && error.country}
                                    errorMsg={error.country}
                                    onChange={(e) => setCountry(e.target.value)}
                                />

                                <div className="rowBlock">
                                    <div className="inputRowGroup mrgRight8">
                                        <small className="inpLabel">{l.select_state}<span className="redTxt">*</span>:</small>
                                        <AddrDropDown
                                            placeholder={l.select_state}
                                            items={states}
                                            value={state}
                                            error={error && error.state}
                                            errorMsg={error.state}
                                            onChange={(e) => setState(e.target.value)}
                                        />
                                    </div>
                                    <div className="inputRowGroup">
                                        <small className="inpLabel">{l.select_city}<span className="redTxt">*</span>:</small>
                                        <AddrDropDown
                                            placeholder={l.select_city}
                                            items={cities}
                                            value={city}
                                            error={error && error.city}
                                            errorMsg={error.city}
                                            onChange={(e) => setCity(e.target.value)}
                                        />
                                    </div>
                                </div> */}
                                <small className="inpLabel">{l.pass}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.pass}
                                    type="password"
                                    value={password}
                                    error={error && error.password}
                                    errorMsg={error.password}
                                    showPwd={true}
                                    maxLength="30"
                                    onChange={(e) => {
                                        setPassword(e.target.value)
                                        setError({...error, password: ""})
                                        }
                                    }
                                />
                                {/* <span className="smallPTxt">{l.pwd_security}</span> */}

                                <small className="inpLabel">{l.confirm_pwd}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.confirm_pwd}
                                    type="password"
                                    value={confirmpassword}
                                    error={error && error.confirmpassword}
                                    errorMsg={error.confirmpassword}
                                    showPwd={true}
                                    maxLength="30"
                                    onChange={(e) => {
                                        setConfirmPassword(e.target.value)
                                        setError({...error, confirmpassword: ""})
                                        }
                                    }
                                />
                                <span className="smallPTxt">{l.pwd_security}</span>
                                <div className="flexCol mrgnTSM">
                                    <FormControlLabel
                                        className='rBox'
                                        control={
                                        <Checkbox
                                            style={{ paddingTop: "0px" }}
                                            name="checkedFirst"
                                            color="primary"
                                            checked={signupFieldsData.checkedFirst}
                                            onChange={(e) => {
                                                setSignupFieldsData((prevState) => ({
                                                    ...prevState,
                                                    checkedFirst: e && e.target && e.target.checked ? e.target.checked : false,
                                                }))
                                                setError({...error, checkedFirst: ""})
                                                }
                                            }
                                        />
                                        }
                                        label = { <span> {l.check_box_one} <strong>{support? support.brandName:"InstaVC"}</strong>{" "}
                                        and{" "}
                                        <a
                                            href={support && support.concern && support.concern !== ""? "/patient-concern" :"https://www.instavc.com/en-in/privacy-policy/"}
                                            style={{ color: "#01A2C4", textDecoration: "underline" }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            data-cmp-ab="2"
                                        >
                                        Privacy Policy.
                                        </a>                               
                                        </span>}
                                    />
                                    {error.checkedFirst && <span className="inputErrorMsg">{l.check_box_error}</span>}

                                    <FormControlLabel
                                        className='rBox'
                                        control={
                                        <Checkbox
                                            style={{ paddingTop: "0px" }}
                                            name="checkedSecond"
                                            color="primary"
                                            checked={signupFieldsData.checkedSecond}
                                            onChange={(e) => {
                                                setSignupFieldsData((prevState) => ({
                                                    ...prevState,
                                                    checkedSecond: e && e.target && e.target.checked ? e.target.checked : false,
                                                }))
                                                setError({...error, checkedSecond: ""})
                                                }
                                            }
                                        />
                                        }
                                        label = { <span> {l.check_box_one} <strong>{support? support.brandName:"InstaVC"}</strong>{" "}
                                        and{" "}
                                        <a 
                                            href={support && support.terms && support.terms !== ""? '/terms-conditions' :"https://www.inclinic.vc/terms-and-conditions/"}
                                            style={{ color: "#01A2C4", textDecoration: "underline" }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            data-cmp-ab="2">
                                            {" "}
                                            {l.terms_cond}{" "}
                                        </a>                             
                                        </span>}
                                    />
                                    {error.checkedSecond && <span className="inputErrorMsg">{l.check_box_error}</span>}

                                    <FormControlLabel
                                        className='rBox'
                                        control={
                                        <Checkbox
                                            style={{ paddingTop: "0px" }}
                                            name="checkedThird"
                                            color="primary"
                                            checked={signupFieldsData.checkedThird}
                                            onChange={(e) => {
                                                setSignupFieldsData((prevState) => ({
                                                    ...prevState,
                                                    checkedThird: e && e.target && e.target.checked ? e.target.checked : false,
                                                }))
                                                setError({...error, checkedThird: ""})
                                                }
                                            }
                                        />
                                        }
                                        label = {<span className="pvcyplcy" > {l.check_box_two}
                                        </span>}
                                    />
                                    {error.checkedThird && <span className="inputErrorMsg">{l.check_box_error}</span>}

                                    </div>
                                    

                                

                                <form id="forgotform" onSubmit={handleSignupBtn}>
                                    <div className="crdBtnContainer">
                                        <Button onClick={handleSignupBtn}
                                            label={l.create_account}
                                            type='primary'
                                            size='md'
                                            fullWidth="fullWidth"
                                        />
                                    </div>
                                </form>                                {/* <div className="crdRowBlock mrgTop24">
                                    <small className="pTxt blackInactiveTxt txtCenter">{l.Copyright} I agree to the
                                        <a href="https://www.inclinic.vc/terms-and-conditions/" target="_blank" className="linkTxt linkTxtSm"> {l.terms_cond}</a>
                                    </small>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className="footerRow">
                        <div className="rowSpaceBtwn">
                            <p className="pTxt mrgRight8">{l.alrdy_have_acct}</p>
                            <Link to="/" className="linkTxt linkTxtMd">{l.login}</Link>
                        </div>
                        <div className="crdRowBlock">
                            <small className="smallTxt blackInactiveTxt txtCenter">{l.Copyright} I agree to the
                                <a href={support && support.terms && support.terms !== ""? '/terms-conditions' :"https://www.inclinic.vc/terms-and-conditions/"} rel="noopener noreferrer" target="_blank" className="linkTxt linkTxtSm"> {l.terms_cond}</a>
                            </small>
                        </div>
                        {support === null && <small className="smallTxt txtCenter blackInactiveTxt">
                            {l.contact_for}{" "}
                            <a href="https://help.peoplelinkvc.com/portal/en/newticket" target="_blank" rel="noopener noreferrer" className="linkTxt linkTxtSm">
                                {l.support}
                            </a>
                        </small>}
                        {support !== null && <div className="flexRow justifyCenter pdngXXXS">
                            {support && support?.phone && <div className="flexInline alignCntr">
                                <a className='tollfree flexInline alignCntr' href={`tel:${support.phone}`} rel="noopener noreferrer">
                                    <img src="/images/icons/Support.png" alt="img" />
                                    <small className="linkTxt linkTxtSm pdngXXXS">{support.phone}</small>
                                </a>
                            </div>}
                            {support && support?.email && <div className="flexInline alignCntr pdngXXXS" onClick={() => handleOpenGmail(support.email)}>
                                <img src="/images/icons/Mail.png" alt="img" />
                                <small className="linkTxt linkTxtSm pdngXXXS">{support.email}</small>
                            </div>}
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    </Fragment>;
};

export default PatientSignupPage;